"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactNativeWeb = require("react-native-web");

var _AaCalendar = require("./AaCalendar.model");

var _AaCalendarWidget = _interopRequireDefault(require("./airasia-calendar-widget/AaCalendarWidget.component"));

var _crossPlatformComponents = require("@airasia/cross-platform-components");

var _uiUtils = require("@airasia/ui-utils");

var _reactRedux = require("react-redux");

var _AaHelpers = require("../../../utils/AaHelpers");

var _EnvironmentUrl = _interopRequireDefault(require("../../../config/environment/EnvironmentUrl"));

var _AaPlatform = _interopRequireDefault(require("../../../utils/AaPlatform"));

var _AaCalendar2 = require("./AaCalendar.utilities");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var DEFAULT_OFFSET = {
  CHECKIN: 7,
  CHEKCOUT: 10,
  RANGE: 3
};
var NATIVE_ID = {
  MAIN: 'hsw-calendar-web',
  HEADER: 'aaCalendar-header-hotel',
  FOOTER: 'aaCalendar-footer-hotel'
};

var AaCalendar = function AaCalendar(props) {
  var defaultDepart = _AaCalendar2.AaCalendarUtilities.addDaysToDate(new Date(), DEFAULT_OFFSET.CHECKIN);

  var defaultCheckout = _AaCalendar2.AaCalendarUtilities.addDaysToDate(new Date(), DEFAULT_OFFSET.CHEKCOUT);

  var _useState = (0, _react.useState)(defaultDepart),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      tempCheckin = _useState2[0],
      setTempCheckin = _useState2[1];

  var _useState3 = (0, _react.useState)(defaultCheckout),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      tempCheckout = _useState4[0],
      setTempCheckout = _useState4[1];

  var _useState5 = (0, _react.useState)(_AaCalendar2.AaCalendarUtilities.formatDates(tempCheckin)),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      checkinDate = _useState6[0],
      setCheckinDate = _useState6[1];

  var _useState7 = (0, _react.useState)(_AaCalendar2.AaCalendarUtilities.formatDates(tempCheckout)),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      checkoutDate = _useState8[0],
      setCheckoutDate = _useState8[1];

  var _useState9 = (0, _react.useState)(true),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      selectForCheckin = _useState10[0],
      setSelectForCheckin = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      selectForCheckout = _useState12[0],
      setSelectForCheckout = _useState12[1];

  var _useState13 = (0, _react.useState)(true),
      _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
      newInstance = _useState14[0],
      setNewInstance = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
      showCalendarModal = _useState16[0],
      setShowCalendarModal = _useState16[1];

  var _useState17 = (0, _react.useState)(true),
      _useState18 = (0, _slicedToArray2["default"])(_useState17, 2),
      disableButtons = _useState18[0],
      setDisableButtons = _useState18[1];

  var _useState19 = (0, _react.useState)(false),
      _useState20 = (0, _slicedToArray2["default"])(_useState19, 2),
      toReset = _useState20[0],
      setToReset = _useState20[1];

  var maxDate = _AaCalendar2.AaCalendarUtilities.addDaysToDate(new Date(), props.controls.maxDays);

  var calculatedViewType = _AaPlatform["default"].IS_MOBILE && props.controls.layout.isTablet || props.controls.layout.isMobile ? _AaCalendar.CALENDAR_VIEW_TYPE.MOBILE : _AaCalendar.CALENDAR_VIEW_TYPE.DESKTOP;
  var viewType = props.controls.viewType || calculatedViewType;

  var _useState21 = (0, _react.useState)({
    dates: {
      checkinDate: tempCheckin,
      checkoutDate: tempCheckout
    }
  }),
      _useState22 = (0, _slicedToArray2["default"])(_useState21, 2),
      calendarOutput = _useState22[0],
      setCalendarOutput = _useState22[1];

  var _useState23 = (0, _react.useState)(props.controls.maxRangeDays + DEFAULT_OFFSET.CHECKIN),
      _useState24 = (0, _slicedToArray2["default"])(_useState23, 2),
      maxCheckoutDays = _useState24[0],
      setMaxCheckoutDays = _useState24[1];

  var _useState25 = (0, _react.useState)(false),
      _useState26 = (0, _slicedToArray2["default"])(_useState25, 2),
      invalidCheckin = _useState26[0],
      setInvalidCheckin = _useState26[1];

  var _useState27 = (0, _react.useState)(false),
      _useState28 = (0, _slicedToArray2["default"])(_useState27, 2),
      invalidCheckout = _useState28[0],
      setInvalidCheckout = _useState28[1];

  var handleCalendarFocus = (0, _react.useCallback)(function (isFocus) {
    if (props.controls.onFocus) {
      props.controls.onFocus(isFocus);
    }
  }, [props.controls.onFocus]);
  (0, _react.useEffect)(function () {
    var _props$controls$layou = props.controls.layout,
        isDesktop = _props$controls$layou.isDesktop,
        isTablet = _props$controls$layou.isTablet,
        isMobile = _props$controls$layou.isMobile;

    if (_AaPlatform["default"].IS_WEB && (isDesktop || isTablet)) {
      var _props$controls = props.controls,
          isDestinationStationSelected = _props$controls.isDestinationStationSelected,
          isCalendarOpenedByDeepLink = _props$controls.isCalendarOpenedByDeepLink;

      if (isDestinationStationSelected || isCalendarOpenedByDeepLink) {
        setNewInstance(true);
        setShowCalendarModal(true);
        handleCalendarFocus(true);
      }
    }

    var isTabletOrMobileWeb = _AaPlatform["default"].IS_MOBILE || isMobile;

    if (!isTabletOrMobileWeb || props.widgetData.checkinDate === null) {
      props.controls.calendarOutput({
        dates: {
          checkinDate: tempCheckin,
          checkoutDate: tempCheckout
        }
      });
    }
  }, [props.controls.isDestinationStationSelected]);

  var isValidDate = function isValidDate(dateString) {
    return dateString && Boolean(Date.parse(dateString));
  };

  (0, _react.useEffect)(function () {
    if (!props.widgetData) {
      return;
    }

    var receivedCheckin = props.widgetData.checkinDate;
    var receivedCheckout = props.widgetData.checkoutDate;
    var validCheckin = isValidDate(receivedCheckin);
    var validCheckout = isValidDate(receivedCheckout);
    var finalCheckin = defaultDepart;
    var finalCheckout = defaultCheckout;

    if (!validCheckin && !validCheckout) {
      return;
    }

    if (validCheckin) {
      var isBeforeToday = _AaCalendar2.AaCalendarUtilities.checkIfDateIsPreviousOfStartDate(receivedCheckin, new Date());

      var isAfterMaxDate = _AaCalendar2.AaCalendarUtilities.checkIfDateIsAheadOfStartDate(receivedCheckin, maxDate);

      if (!(isBeforeToday || isAfterMaxDate)) {
        finalCheckin = receivedCheckin;
      }
    }

    onDepartChangeHandler(finalCheckin);
    finalCheckout = _AaCalendar2.AaCalendarUtilities.addDaysToDate(finalCheckin, DEFAULT_OFFSET.RANGE);

    if (validCheckout) {
      var maxRangeDate = _AaCalendar2.AaCalendarUtilities.addDaysToDate(finalCheckin, props.controls.maxRangeDays);

      var isAfterMaxRangeDate = _AaCalendar2.AaCalendarUtilities.checkIfDateIsAheadOfStartDate(receivedCheckout, maxRangeDate);

      var _isAfterMaxDate = _AaCalendar2.AaCalendarUtilities.checkIfDateIsAheadOfStartDate(receivedCheckout, maxDate);

      var isBeforeCheckinDate = _AaCalendar2.AaCalendarUtilities.checkIfDateIsPreviousOfStartDate(receivedCheckout, finalCheckin);

      var isInMaxRange = !(isAfterMaxRangeDate || _isAfterMaxDate);

      if (isInMaxRange && !isBeforeCheckinDate) {
        finalCheckout = receivedCheckout;
      }
    }

    onReturnChangeHandler(finalCheckout);
    var didCheckinChange = finalCheckin !== receivedCheckin;
    var didCheckoutChange = finalCheckout !== receivedCheckout;

    if (didCheckinChange || didCheckoutChange) {
      props.controls.calendarOutput({
        dates: {
          checkinDate: finalCheckin,
          checkoutDate: finalCheckout
        }
      });
    }
  }, [props.widgetData.checkinDate, props.widgetData.checkoutDate]);
  (0, _react.useEffect)(function () {
    setDisableButtons(checkButtonState(checkinDate, checkoutDate));
  }, [checkinDate, checkoutDate]); // HANDLERS

  var onFocusDepart = function onFocusDepart(val) {
    toggleDateSelectionHandler(_AaCalendar.TOGGLE_DATE_SELECTION.DEPART);
    setNewInstance(true);
    setShowCalendarModal(true);
    handleCalendarFocus(true);
  };

  var onFocusReturn = function onFocusReturn(val) {
    toggleDateSelectionHandler(_AaCalendar.TOGGLE_DATE_SELECTION.RETURN);
    setShowCalendarModal(true);
    handleCalendarFocus(true);
  };

  (0, _react.useEffect)(function () {
    if (_AaPlatform["default"].IS_MOBILE) {
      return;
    }

    document.addEventListener('keyup', keyUpHandler);
    return function () {
      return document.removeEventListener("keyup", keyUpHandler);
    };
  }, [tempCheckin, tempCheckout]);

  var keyUpHandler = function keyUpHandler() {
    if (_AaPlatform["default"].IS_MOBILE) {
      return;
    }

    var mainElement = document.getElementById(NATIVE_ID.MAIN);
    var isChild = mainElement && mainElement.contains(document.activeElement);

    if (!isChild) {
      document.removeEventListener("keyup", keyUpHandler);
      onDonePress();
    }
  };

  var onDonePress = function onDonePress() {
    var departHolder = tempCheckin;
    var returnHolder = tempCheckout;
    setShowCalendarModal(false);
    setNewInstance(true);
    handleCalendarFocus(false);

    if (!checkinDate) {
      onDepartChangeHandler(tempCheckin);
    }

    if (!tempCheckin) {
      departHolder = defaultDepart;
    }

    if (!checkoutDate || _AaCalendar2.AaCalendarUtilities.checkIfDateIsPreviousOfStartDate(tempCheckout, tempCheckin)) {
      returnHolder = _AaCalendar2.AaCalendarUtilities.addDaysToDate(tempCheckin, 3);
      onReturnChangeHandler(returnHolder);
    }

    if (!tempCheckin) {
      setCheckinDate(_AaCalendar2.AaCalendarUtilities.formatDates(defaultDepart));
      setTempCheckin(defaultDepart);
      props.controls.calendarOutput({
        dates: {
          checkinDate: defaultDepart,
          checkoutDate: null
        }
      });
      return;
    } else if (!tempCheckin && !tempCheckout) {
      setCheckinDate(_AaCalendar2.AaCalendarUtilities.formatDates(defaultDepart));
      setCheckoutDate(_AaCalendar2.AaCalendarUtilities.formatDates(defaultCheckout));
      setTempCheckin(defaultDepart);
      setTempCheckout(defaultCheckout);
      props.controls.calendarOutput({
        dates: {
          checkinDate: defaultDepart,
          checkoutDate: defaultCheckout
        }
      });
      return;
    }

    props.controls.calendarOutput({
      dates: {
        checkinDate: departHolder,
        checkoutDate: returnHolder
      }
    });
  };

  var onValueChange = function onValueChange(attr, val) {
    if (attr === _AaCalendar2.INPUT_ATTR_NAME.FROM) {
      setCheckinDate(val);
    }

    if (attr === _AaCalendar2.INPUT_ATTR_NAME.TO) {
      setCheckoutDate(val);
    }

    if (val.length < 10) {
      return;
    }

    if (attr === _AaCalendar2.INPUT_ATTR_NAME.FROM) {
      var inputDate = _AaCalendar2.AaCalendarUtilities.formatDateInputFormat(val);

      if (inputDate) {
        var newDate = new Date(inputDate);

        var beyondMaxDate = _AaCalendar2.AaCalendarUtilities.checkIfDateIsAheadOfStartDate(newDate, maxDate);

        var previousOfStartDate = _AaCalendar2.AaCalendarUtilities.checkIfDateIsPreviousOfStartDate(newDate, new Date());

        if (beyondMaxDate || previousOfStartDate) {
          setCheckinDate(_AaCalendar2.AaCalendarUtilities.formatDates(tempCheckin));
          return;
        }

        onDepartChangeHandler(newDate);

        var beyondReturnDate = _AaCalendar2.AaCalendarUtilities.checkIfDateIsAheadOfStartDate(newDate, tempCheckout);

        if (!beyondReturnDate) {
          return;
        }

        onReturnChangeHandler(null);
      } else {
        setCheckinDate(_AaCalendar2.AaCalendarUtilities.formatDates(tempCheckin));
      }
    }

    if (attr === _AaCalendar2.INPUT_ATTR_NAME.TO) {
      setCheckoutDate(val);

      var _inputDate = _AaCalendar2.AaCalendarUtilities.formatDateInputFormat(val);

      if (_inputDate) {
        var _newDate = new Date(_inputDate);

        var maxCheckoutDate = _AaCalendar2.AaCalendarUtilities.addDaysToDate(new Date(), maxCheckoutDays);

        var _beyondMaxDate = !_AaCalendar2.AaCalendarUtilities.checkIfDateIsPreviousOrEqualOfStartDate(_newDate, maxCheckoutDate);

        var beforeOrEqualToCheckin = _AaCalendar2.AaCalendarUtilities.checkIfDateIsPreviousOrEqualOfStartDate(_newDate, tempCheckin);

        if (_beyondMaxDate || beforeOrEqualToCheckin) {
          setCheckoutDate(_AaCalendar2.AaCalendarUtilities.formatDates(tempCheckout));
          return;
        }

        onReturnChangeHandler(_newDate);
      } else {
        setCheckoutDate(_AaCalendar2.AaCalendarUtilities.formatDates(tempCheckout));
      }
    }
  };

  var onResetHandler = function onResetHandler() {
    setCheckinDate('');
    setCheckoutDate('');
    setTempCheckin(null);
    setTempCheckout(null);
    setToReset(true);
    setCalendarOutput(_objectSpread(_objectSpread({}, calendarOutput), {}, {
      dates: {
        checkinDate: null,
        checkoutDate: null
      }
    }));
  };

  var onConfirmHandler = function onConfirmHandler() {
    onDonePress();
  };

  var onDepartChangeHandler = function onDepartChangeHandler(dates) {
    var checkinDate = '';
    var checkinDateObj = dates || null;

    if (checkinDateObj) {
      checkinDate = _AaCalendar2.AaCalendarUtilities.formatDates(checkinDateObj);
    }

    setCheckinDate(checkinDate);
    setTempCheckin(dates);
    setInvalidCheckin(!checkinDateObj);

    var maxCheckoutDate = _AaCalendar2.AaCalendarUtilities.addDaysToDate(checkinDateObj, props.controls.maxRangeDays);

    var nextMaxCheckoutDays = Math.min(_AaCalendar2.AaCalendarUtilities.daysAfterToday(maxCheckoutDate), props.controls.maxDays);
    setMaxCheckoutDays(nextMaxCheckoutDays);
    setCalendarOutput(_objectSpread(_objectSpread({}, calendarOutput), {}, {
      dates: {
        checkinDate: checkinDateObj,
        checkoutDate: calendarOutput.dates.checkoutDate
      }
    }));
    setToReset(false);
    var currentCheckoutDate = calendarOutput.dates.checkoutDate;

    var isAfterMaxDate = _AaCalendar2.AaCalendarUtilities.checkIfDateIsAheadOfStartDate(currentCheckoutDate, maxCheckoutDate);

    if (isAfterMaxDate) {
      onReturnChangeHandler(maxCheckoutDate);
    }
  };

  var onReturnChangeHandler = function onReturnChangeHandler(dates) {
    var checkoutDate = '';
    var checkoutDateObj = dates || null;

    if (checkoutDateObj) {
      checkoutDate = _AaCalendar2.AaCalendarUtilities.formatDates(checkoutDateObj);
    }

    setCheckoutDate(checkoutDate);
    setTempCheckout(dates);
    setInvalidCheckout(!checkoutDateObj);
    setCalendarOutput(_objectSpread(_objectSpread({}, calendarOutput), {}, {
      dates: {
        checkinDate: calendarOutput.dates.checkinDate,
        checkoutDate: checkoutDateObj
      }
    }));
    setToReset(false);
  };

  var checkButtonState = function checkButtonState(checkinDate, checkoutDate) {
    if (checkinDate && checkinDate !== '' && checkoutDate && checkoutDate !== '') {
      return false;
    }

    return true;
  };

  var borderStyleReturn = {
    flex: 1,
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  };
  var borderStyleOneWay = {
    flex: 1,
    borderRadius: 4
  }; // CONFIGS

  var hideCalendarIcon = props.controls.hideCalendarIcon;
  var textDepartInputConfig = {
    controls: {
      attrName: _AaCalendar2.INPUT_ATTR_NAME.FROM,
      value: checkinDate,
      updateMasterState: onValueChange,
      isFloatingLabelRequired: true,
      onInputFocus: onFocusDepart,
      textInputStyles: {
        color: '#212124'
      },
      textInputContainerStyle: borderStyleReturn,
      selectTextOnFocus: true,
      inputContainerIconName: !hideCalendarIcon && _crossPlatformComponents.AaIconTypes.CALENDAR,
      inputContainerIconAccessibility: false
    },
    translation: {
      title: props.translation.departLabel,
      placeholder: ''
    }
  };
  var textReturnInputConfig = {
    controls: {
      attrName: _AaCalendar2.INPUT_ATTR_NAME.TO,
      value: checkoutDate,
      updateMasterState: onValueChange,
      isFloatingLabelRequired: true,
      onInputFocus: onFocusReturn,
      textInputStyles: {
        color: '#212124'
      },
      textInputContainerStyle: {
        flex: 1,
        borderTopRightRadius: 4,
        borderBottomRightRadius: 4,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        borderLeftWidth: 0.5
      },
      selectTextOnFocus: true,
      inputContainerIconName: !hideCalendarIcon && _crossPlatformComponents.AaIconTypes.CALENDAR,
      inputContainerIconAccessibility: false
    },
    translation: {
      title: props.translation.returnLabel,
      placeholder: ''
    }
  };
  var buttonsConfig = {
    reset: {
      controls: {
        onButtonPress: onResetHandler,
        customStyle: {
          container: {
            backgroundColor: '#fff',
            borderColor: '#e10000',
            borderWidth: 1,
            paddingVertical: 10,
            web: {
              paddingVertical: 8
            }
          },
          text: {
            color: '#e10000'
          }
        }
      },
      data: {
        text: props.translation.resetLabel
      }
    },
    confirm: {
      controls: {
        onButtonPress: onConfirmHandler,
        customStyle: {
          container: {
            borderWidth: 1,
            borderColor: '#e10000',
            paddingVertical: 10,
            web: {
              paddingVertical: 8
            }
          }
        }
      },
      data: {
        text: props.translation.confirmLabel
      }
    }
  };

  var toggleDateSelectionHandler = function toggleDateSelectionHandler(type) {
    if (type === _AaCalendar.TOGGLE_DATE_SELECTION.DEPART) {
      setSelectForCheckin(true);
      setSelectForCheckout(false);
    } else if (type === _AaCalendar.TOGGLE_DATE_SELECTION.RETURN) {
      setSelectForCheckin(false);
      setSelectForCheckout(true);
      setNewInstance(false);
    }
  };

  var calendarModalConfig = {
    controls: {
      // onDateChange: onDateChangeHandler,
      onDepartChange: onDepartChangeHandler,
      onReturnChange: onReturnChangeHandler,
      maxDays: selectForCheckin ? props.controls.maxDays : maxCheckoutDays,
      viewType: viewType,
      layout: props.controls.layout,
      isLogin: props.controls.isLogin,
      toggleDateSelection: toggleDateSelectionHandler
    }
  };

  var checkAnimatedStyles = function checkAnimatedStyles(val) {
    if (val) {
      return {
        fontSize: 12,
        top: 6
      };
    } else {
      return {
        fontSize: 16
      };
    }
  };

  (0, _react.useEffect)(function () {
    getDateDataFormat(props.controls.locale);
  }, [props.controls.locale]);

  var getDateDataFormat = function getDateDataFormat(locale) {
    if (!locale) {
      locale = 'en-gb';
    }

    props.make_async_get_call((0, _AaHelpers.format)(_EnvironmentUrl["default"][props.controls.environment].DATA_FORMAT.DATE, [locale]), {}, _AaCalendar.DATA_FORMAT_STATE_KEY.DATE, false, null);
  };

  (0, _react.useEffect)(function () {
    if (!props.dataFormatDate) {
      return;
    }

    if (!props.dataFormatDate.userData || !props.dataFormatDate.userData.data) {
      return;
    }

    _AaCalendar2.AaCalendarUtilities.setDateFormat(props.dataFormatDate.userData.data);

    setTextInputDateFormat(props.dataFormatDate.userData.data.date.general);
  }, [props.dataFormatDate]);

  var setTextInputDateFormat = function setTextInputDateFormat(format) {
    setCheckinDate(_AaCalendar2.AaCalendarUtilities.formatDates(tempCheckin, format));
    setCheckoutDate(_AaCalendar2.AaCalendarUtilities.formatDates(tempCheckout, format));
  };

  var isIE = function isIE() {
    if (_AaPlatform["default"].IS_WEB) {
      var ua = navigator.userAgent;
      /* MSIE used to detect old browsers and Trident used to newer ones*/

      var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
      return is_ie;
    }
  };

  var mobileInputContainer = function mobileInputContainer() {
    return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: [styles.calendarHeaderItem, styles.calendarInputContainer, showCalendarModal && {
        minHeight: 62
      }]
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: styles.touchFeedBackContainer
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.TouchableWithoutFeedback, {
      onPress: onFocusDepart
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: newInstance && showCalendarModal && selectForCheckin && [styles.calendarInputHolderActive, styles.calendarInputHolderActiveLeft]
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: [styles.mobileContainer, (!checkinDate || checkinDate === '') && styles.mobileContainerEmpty, true ? styles.mobileContainerDepart : {
        borderRadius: 4
      }, newInstance && showCalendarModal && selectForCheckin && styles.mobileContainerActive]
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Animated.Text, {
      style: [checkAnimatedStyles(checkinDate), styles.titleStyles, styles.fontRegular]
    }, props.translation.departLabel), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
      numberOfLines: 1,
      ellipsizeMode: "clip",
      style: [{
        marginTop: 24,
        marginLeft: 15
      }, styles.dateStyles]
    }, checkinDate)), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: styles.textInputContainerIcon
    }, props.controls.hideCalendarIcon && /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaIconComponent, {
      controls: {
        iconName: _crossPlatformComponents.AaIconTypes.CALENDAR,
        iconStyle: {
          height: 24,
          width: 24
        }
      }
    }))))), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: styles.touchFeedBackContainer
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.TouchableWithoutFeedback, {
      onPress: onFocusReturn
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: showCalendarModal && selectForCheckout && [styles.calendarInputHolderActive, styles.calendarInputHolderActiveRight]
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: [styles.mobileContainer, (!checkoutDate || checkoutDate === '') && styles.mobileContainerEmpty, styles.mobileContainerReturn, showCalendarModal && selectForCheckout && styles.mobileContainerActive]
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Animated.Text, {
      style: [checkAnimatedStyles(checkoutDate), styles.titleStyles, styles.fontRegular]
    }, props.translation.returnLabel), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
      numberOfLines: 1,
      ellipsizeMode: "clip",
      style: [{
        marginTop: 24,
        marginLeft: 15
      }, styles.dateStyles]
    }, checkoutDate)), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: styles.textInputContainerIcon
    }, props.controls.hideCalendarIcon && /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaIconComponent, {
      controls: {
        iconName: _crossPlatformComponents.AaIconTypes.CALENDAR,
        iconStyle: {
          height: 24,
          width: 24
        }
      }
    }))))));
  };

  var mobileCalendar = function mobileCalendar() {
    return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: styles.modalContainer
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: styles.headerMobile
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.TouchableWithoutFeedback, {
      onPress: onDonePress
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: styles.headerCloseIcon
    }, /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaIconComponent, {
      controls: {
        iconName: "CLOSE_ICON",
        iconStyle: {
          height: 24,
          width: 24
        }
      }
    })))), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      nativeID: NATIVE_ID.HEADER,
      style: [styles.calendarHeaderMobile, styles.calendarHeaderShow, props.controls.layout.isTablet && styles.calendarHeaderTablet]
    }, mobileInputContainer()), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: {
        flex: 1,
        flexDirection: 'column'
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: styles.calendarBody
    }, /*#__PURE__*/_react["default"].createElement(_AaCalendarWidget["default"], {
      controls: _objectSpread(_objectSpread({}, calendarModalConfig.controls), {}, {
        resetData: toReset,
        locale: props.controls.locale,
        currencyDetails: props.controls.currencyDetails,
        environment: props.controls.environment,
        selectForCheckin: showCalendarModal && selectForCheckin,
        selectForCheckout: selectForCheckout
      }),
      dates: {
        checkinDate: tempCheckin,
        checkoutDate: tempCheckout
      },
      widgetData: props.widgetData
    })), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      nativeID: NATIVE_ID.FOOTER,
      style: [styles.calendarFooter, props.controls.layout.isMobile && styles.calendarFooterMobileWeb]
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: [styles.footerItem, styles.footerButton]
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: [styles.footerButtonItem, {
        minHeight: 44,
        marginRight: 16
      }]
    }, /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaButton, {
      controls: _objectSpread(_objectSpread({}, buttonsConfig.reset.controls), {}, {
        disabled: disableButtons
      }),
      data: buttonsConfig.reset.data
    })), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: [styles.footerButtonItem, {
        minHeight: 44
      }]
    }, /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaButton, {
      controls: _objectSpread(_objectSpread({}, buttonsConfig.confirm.controls), {}, {
        disabled: disableButtons
      }),
      data: buttonsConfig.confirm.data
    }))))));
  };

  if (_AaPlatform["default"].IS_WEB && (props.controls.layout.isDesktop || props.controls.layout.isTablet)) {
    return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      nativeID: NATIVE_ID.MAIN,
      style: [styles.calendarContainer, props.controls.isRightAligned && styles.containerToRight, showCalendarModal && styles.calendarContainerShow, showCalendarModal && props.controls.layout.isTablet && styles.calendarContainerShowWebTablet]
    }, showCalendarModal ? /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.TouchableWithoutFeedback, {
      onPress: onDonePress
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: styles.overlay
    })) : null, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      nativeID: NATIVE_ID.HEADER,
      style: [styles.calendarHeader, props.controls.isRightAligned && styles.reverseHeader, props.controls.layout.isTablet && styles.calendarHeaderWebTablet, showCalendarModal && styles.calendarHeaderShow, props.controls.layout.isTablet && showCalendarModal && styles.calendarHeaderShowWebTablet]
    }, showCalendarModal && /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: [styles.calendarHeaderItem, props.controls.layout.isTablet && styles.calendarHeaderItemMobile]
    }), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: [styles.calendarHeaderItem, styles.calendarInputContainer, showCalendarModal && {
        minHeight: 62
      }]
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: [styles.calendarInputHolder, newInstance && showCalendarModal && selectForCheckin && [styles.calendarInputHolderActive, styles.calendarInputHolderActiveLeft], isIE() && {
        height: 56
      }, {
        minHeight: 56
      }]
    }, /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaTextInputComponent, {
      controls: _objectSpread(_objectSpread({}, textDepartInputConfig.controls), {}, {
        value: checkinDate,
        focusTextInput: newInstance && showCalendarModal && selectForCheckin,
        invalidInput: invalidCheckin
      }),
      translation: textDepartInputConfig.translation
    })), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: [styles.calendarInputHolder, showCalendarModal && selectForCheckout && [styles.calendarInputHolderActive, styles.calendarInputHolderActiveRight], isIE() && {
        height: 56
      }, {
        minHeight: 56
      }]
    }, /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaTextInputComponent, {
      controls: _objectSpread(_objectSpread({}, textReturnInputConfig.controls), {}, {
        value: checkoutDate,
        focusTextInput: showCalendarModal && selectForCheckout,
        invalidInput: invalidCheckout
      }),
      translation: textReturnInputConfig.translation
    })))), showCalendarModal && /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, null, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: styles.calendarBody
    }, /*#__PURE__*/_react["default"].createElement(_AaCalendarWidget["default"], {
      controls: _objectSpread(_objectSpread({}, calendarModalConfig.controls), {}, {
        resetData: toReset,
        locale: props.controls.locale,
        currencyDetails: props.controls.currencyDetails,
        environment: props.controls.environment,
        selectForCheckin: showCalendarModal && selectForCheckin,
        selectForCheckout: selectForCheckout
      }),
      dates: {
        checkinDate: tempCheckin,
        checkoutDate: tempCheckout
      },
      widgetData: props.widgetData
    })), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      nativeID: NATIVE_ID.FOOTER,
      style: styles.calendarFooter
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: [styles.footerItem, styles.footerButton]
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: [styles.footerButtonItem, {
        minHeight: 44,
        marginRight: 16
      }]
    }, /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaButton, {
      controls: _objectSpread(_objectSpread({}, buttonsConfig.reset.controls), {}, {
        disabled: disableButtons,
        accessible: false
      }),
      data: buttonsConfig.reset.data
    })), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: [styles.footerButtonItem, {
        minHeight: 44
      }]
    }, /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaButton, {
      controls: _objectSpread(_objectSpread({}, buttonsConfig.confirm.controls), {}, {
        disabled: disableButtons,
        accessible: false
      }),
      data: buttonsConfig.confirm.data
    }))))));
  }

  if (_AaPlatform["default"].IS_MOBILE && props.controls.layout.isTablet || props.controls.layout.isMobile) {
    return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: [styles.calendarContainerMobile]
    }, mobileInputContainer(), /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaModal, {
      isVisible: showCalendarModal,
      wrapperStyle: styles.modal,
      onClose: onDonePress
    }, _AaPlatform["default"].IS_IOS ? /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.SafeAreaView, {
      style: styles.safeAreaView
    }, mobileCalendar()) : mobileCalendar()));
  }
};

var styles = _crossPlatformComponents.StyleSheet.create({
  touchFeedBackContainer: {
    flex: 1
  },
  mobileContainer: {
    borderRadius: 4,
    borderStyle: 'solid',
    borderWidth: 0.5,
    height: 56,
    borderColor: "#c5c9d0",
    backgroundColor: '#fff'
  },
  mobileContainerActive: {
    borderRadius: 3,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: "#4b4fa6",
    borderLeftWidth: 1
  },
  mobileContainerDepart: {
    borderBottomLeftRadius: 4,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  },
  mobileContainerReturn: {
    borderBottomRightRadius: 4,
    borderTopRightRadius: 4,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderLeftWidth: 0
  },
  mobileContainerEmpty: {
    justifyContent: 'center'
  },
  titleStyles: {
    position: 'absolute',
    left: 15
  },
  titleStylesEmpty: {
    fontSize: 16
  },
  safeAreaView: {
    flex: 1,
    backgroundColor: "transparent"
  },
  modal: {
    flex: 1,
    backgroundColor: '#FFF',
    ios: {
      backgroundColor: '#FFF'
    }
  },
  modalContainer: {
    ios: {
      flex: 1,
      flexDirection: 'column',
      height: '100%'
    },
    android: {
      flex: 1,
      flexDirection: 'column',
      height: '100%'
    },
    position: 'absolute',
    web: {
      position: 'fixed'
    },
    top: 0,
    left: 0,
    width: '100%'
  },
  headerMobile: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 56,
    justifyContent: 'flex-end',
    backgroundColor: '#fff',
    borderBottomWidth: 0,
    web: {
      shadowOffset: {
        width: 0,
        height: 2
      },
      shadowOpacity: 0.25,
      shadowRadius: 3.84
    },
    android: {
      backgroundColor: '#fff',
      elevation: 9
    }
  },
  overlay: {
    web: {
      position: 'fixed',
      overflowY: 'auto'
    },
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 0,
    flex: 1,
    android: {
      elevation: 0
    }
  },
  calendarContainer: {
    width: '100%',
    position: 'absolute',
    right: 0,
    top: -10
  },
  containerToRight: {
    left: 0
  },
  calendarContainerShow: {
    width: 700
  },
  calendarContainerShowWebTablet: {
    width: 'auto',
    left: 0
  },
  calendarContainerMobile: {
    marginTop: 10
  },
  calendarContainerMobileShow: {
    position: 'absolute',
    top: -15,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 2,
    marginTop: 0,
    elevation: 2
  },
  calendarHeaderMobile: {
    flexDirection: 'column',
    padding: 0
  },
  calendarHeaderTablet: {
    flexDirection: 'row',
    alignItems: 'center',
    android: {
      height: 80
    },
    ios: {
      height: 80
    }
  },
  calendarHeader: {
    flexDirection: 'row',
    padding: 10
  },
  reverseHeader: {
    flexDirection: 'row-reverse'
  },
  calendarHeaderWebTablet: {
    padding: 0,
    marginTop: 25
  },
  calendarHeaderShow: {
    backgroundColor: '#f8f8f8',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderWidth: 1,
    borderColor: '#d9dbe0',
    padding: 10,
    paddingHorizontal: 16,
    android: {
      height: 132
    },
    ios: {
      height: 132
    }
  },
  calendarHeaderShowWebTablet: {
    flexDirection: 'column',
    padding: 10
  },
  calendarBody: {
    backgroundColor: '#fff',
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderColor: '#bfc5cf',
    padding: 16,
    web: {
      paddingVertical: 10
    }
  },
  calendarHeaderItem: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center' // marginBottom: 15

  },
  calendarHeaderItemMobile: {
    marginVertical: 15
  },
  // calendarHeaderItemTablet: {
  //     marginBottom: 0
  // },
  calendarInputContainer: {
    justifyContent: 'flex-end',
    marginBottom: 0
  },
  calendarInputHolder: {
    flex: 1
  },
  calendarInputHolderActive: {
    borderWidth: 3,
    borderColor: '#d9dbe0'
  },
  calendarInputHolderActiveFull: {
    borderRadius: 6
  },
  calendarInputHolderActiveLeft: {
    borderTopLeftRadius: 6,
    borderBottomLeftRadius: 6
  },
  calendarInputHolderActiveRight: {
    borderTopRightRadius: 6,
    borderBottomRightRadius: 6
  },
  calendarFooterMobileWeb: {
    web: {
      position: 'fixed',
      bottom: 0,
      width: '100%'
    }
  },
  calendarFooter: {
    flexDirection: 'row',
    backgroundColor: '#fff',
    borderWidth: 1,
    android: {
      position: 'absolute',
      bottom: 0,
      borderBottomWidth: 0
    },
    ios: {
      position: 'absolute',
      bottom: 0,
      borderBottomWidth: 0
    },
    borderColor: '#bfc5cf',
    padding: 15,
    web: {
      paddingVertical: 13,
      paddingHorizontal: 15
    }
  },
  footerItem: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center'
  },
  footerLabel: {
    fontSize: 12,
    color: '#000',
    fontFamily: _uiUtils.DefaultTokens.FONT_REGULAR,
    web: {
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB
    }
  },
  footerButton: {
    flex: 2,
    justifyContent: 'flex-end'
  },
  footerButtonItem: {
    width: 100
  },
  TabletView: {
    web: {
      paddingHorizontal: 0,
      paddingBottom: 10,
      paddingTop: 30
    }
  },
  textInputContainerIcon: {
    position: 'absolute',
    right: 0,
    top: 15
  },
  fontRegular: {
    fontSize: 12,
    color: '#75767A',
    fontFamily: _uiUtils.DefaultTokens.FONT_REGULAR,
    web: {
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB,
      fontWeight: '400'
    },
    ios: {
      fontSize: 14
    }
  },
  dateStyles: {
    fontSize: 14,
    color: '#1d1d1d',
    fontFamily: _uiUtils.DefaultTokens.FONT_REGULAR,
    web: {
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB,
      fontWeight: '400'
    },
    ios: {
      fontFamily: _uiUtils.DefaultTokens.FONT_MEDIUM,
      fontSize: 16
    }
  }
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    data: state.updatedState,
    dataFormatDate: state.asyncAction[_AaCalendar.DATA_FORMAT_STATE_KEY.DATE]
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  make_async_get_call: _uiUtils.make_async_get_call
})(AaCalendar);

exports["default"] = _default;